export function dataInRequest(params = {}) {
  return {
    type: '@notafiscalrecebida/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@notafiscalrecebida/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@notafiscalrecebida/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@notafiscalrecebida/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@notafiscalrecebida/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@notafiscalrecebida/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@notafiscalrecebida/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@notafiscalrecebida/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@notafiscalrecebida/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@notafiscalrecebida/RECORD_FILTERING',
    payload: { params },
  };
}
